import "./Bin.scss";

export default {};
